import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteProvider } from "@/context/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import LeadershipPage from "@/pages/LeadershipPage";
import MembersPage from "@/pages/MembersPage";
import MemberProfilePage from "@/pages/MemberProfilePage";
import AlbumPage from "@/pages/AlbumPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import FaqPage from "@/pages/FaqPage";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/leadership" element={<LeadershipPage />} />
            <Route path="/members" element={<MembersPage />} />
            <Route path="/members/:slug" element={<MemberProfilePage />} />
            <Route path="/album" element={<AlbumPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq/what-is-isi-group" element={<FaqPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </SiteProvider>
    </div>
  );
}

export default App;
